import React from 'react';
import { Box, Typography } from '@mui/material';
import { Description as ContractIcon } from '@mui/icons-material';
import { SaveContractButton, CancelContractButton } from '../../commands';

interface ContractCreateHeaderProps {
  company: string;
  isDirty: boolean;
  isEditMode?: boolean;
  contractName?: string;
}

const ContractCreateHeader: React.FC<ContractCreateHeaderProps> = ({ 
  company, 
  isDirty, 
  isEditMode = false, 
  contractName 
}) => (
  <Box sx={{ 
    backgroundColor: '#ffffff',
    borderBottom: '2px solid #3b82f6',
    p: 2.5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <ContractIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
      <Box>
        <Typography 
          variant="h5" 
          sx={{ 
            fontWeight: 600, 
            color: '#1e293b',
            mb: 0.5
          }}
        >
          {isEditMode ? (contractName ? `Edit ${contractName}` : 'Edit Contract') : 'Create New Contract'}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ color: '#64748b' }}
        >
          {company} | {isEditMode ? 'Contract Edit' : 'New Contract Instance'}
          {isDirty && (
            <Typography 
              component="span" 
              sx={{ ml: 2, color: 'warning.main', fontSize: 'inherit' }}
            >
              • Unsaved Changes
            </Typography>
          )}
        </Typography>
      </Box>
    </Box>

    <Box sx={{ display: 'flex', gap: 2 }}>
      <CancelContractButton />
      <SaveContractButton />
    </Box>
  </Box>
);

export default ContractCreateHeader;
